import styled from 'styled-components';

import { ModalBody } from '../../../../../components/DialogRoundedModal';
import colors from '../../../../../styles/colors';

const ModalContent = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 460px;
  overflow-y: auto;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const HEADING_COLOR = {
  failure: colors.shades.danger3,
  warning: colors.base.warning,
  neutral: colors.shades.secondary8,
};

const SectionHeading = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ $tone }) => HEADING_COLOR[$tone] || HEADING_COLOR.neutral};
`;

const ToggleHeading = styled.button`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.shades.secondary8};

  &::before {
    content: '${({ $isOpen }) => ($isOpen ? '▾' : '▸')}';
    margin-right: 6px;
  }
`;

const WorkoutList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const WorkoutRow = styled.li`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
`;

const WorkoutName = styled.span`
  color: ${colors.shades.secondary8};
`;

const WorkoutReason = styled.span`
  flex-shrink: 0;
  font-size: 12px;
  color: ${colors.shades.secondary6};
`;

export {
  ModalContent,
  Section,
  SectionHeading,
  ToggleHeading,
  WorkoutList,
  WorkoutRow,
  WorkoutName,
  WorkoutReason,
};
